import {
  RepositoryFilterMode,
  RepositorySortMode,
  RepositoryViewModel,
} from "../types";

export const filterRepositories = (
  repositories: RepositoryViewModel[],
  options: { query: string; filter: RepositoryFilterMode; owner: string }
) => {
  const search = options.query.trim().toLowerCase();

  return repositories.filter((repo) => {
    if (options.filter === "favorites" && !repo.isFavorite) return false;
    if (options.owner && repo.owner !== options.owner) return false;
    if (search && !repo.searchIndex.includes(search)) return false;
    return true;
  });
};

export const sortRepositories = (
  repositories: RepositoryViewModel[],
  sort: RepositorySortMode
) => {
  const result = [...repositories];

  if (sort === "nameAsc") {
    result.sort((a, b) => a.name.localeCompare(b.name));
    return result;
  }

  if (sort === "updatedDesc") {
    result.sort((a, b) => {
      const aTime = a.updatedAt ? new Date(a.updatedAt).getTime() : 0;
      const bTime = b.updatedAt ? new Date(b.updatedAt).getTime() : 0;
      return bTime - aTime;
    });
    return result;
  }

  result.sort((a, b) => {
    if (a.isFavorite === b.isFavorite) return a.name.localeCompare(b.name);
    return a.isFavorite ? -1 : 1;
  });
  return result;
};

export const extractOwners = (repositories: RepositoryViewModel[]) =>
  Array.from(new Set(repositories.map((repo) => repo.owner))).sort((a, b) =>
    a.localeCompare(b)
  );
